import React from 'react';
import '../../styles/components/AboutTeam.css';

/** Праворуч емблема як фон */
import TeamBg from '../../img/hero/team-logo-bg.png';

/** Тимчасові фото (підставиш свої з Figma) */
import PhotoYV from '../../img/team/yv-3.webp';
import PhotoIS from '../../img/team/is-3.webp';
import PhotoMiroslav from '../../img/team/mm-2.webp';

const TEAM = [
  {
    name: 'Yevhenii Vasylchenko',
    role: 'Co-founder',
    photo: PhotoYV,
    photoClass: 'abt-card__photo--yv',
    linkedin: 'https://www.linkedin.com/in/yevhenii-vasilchenko/',
  },
  {
    name: <>Igor <br /> Skryl</>,
    role: 'Co-founder',
    photo: PhotoIS,
    photoClass: 'abt-card__photo--is',
    linkedin: 'https://www.linkedin.com/in/iskryl/?locale=uk_UA',
  },
  {
    name: 'Myroslav Matviichuk',
    role: 'Head of AI',
    photo: PhotoMiroslav,
    photoClass: 'abt-card__photo--mm',
    linkedin: 'https://www.linkedin.com/in/%D0%BC%D0%B8%D1%80%D0%BE%D1%81%D0%BB%D0%B0%D0%B2-%D0%BC%D0%B0%D1%82%D0%B2%D1%96%D0%B9%D1%87%D1%83%D0%BA-36784729b/',
  },
];

export default function Team() {
  return (
    <section className="abt-team" aria-label="Meet the Minds">
      {/* Заголовок у два рядки — лівий верх */}
      <h1 className="abt-team__heading abt-team-anim">
        <span className="h-line1">Meet the Minds</span>
        <span className="h-line2">
          Behind <em>Intelligent Writing</em>
        </span>
      </h1>

      {/* Емблема праворуч (фон) */}
      <img
        className="abt-team__bg abt-team-anim-bg"
        src={TeamBg}
        alt=""
        aria-hidden="true"
      />

      {/* Ряд карток праворуч поверх фону */}
      <div className="abt-team__cards">
        {TEAM.map((m) => (
          <article
            key={m.name}
            className="abt-card abt-team-anim-card"
            aria-label={m.name}
          >
            <div className="abt-card__meta">
              <div className="abt-card__name">{m.name}</div>
              <div className="abt-card__role">{m.role}</div>
            </div>

            <img
  className={`abt-card__photo ${m.photoClass}`}
  src={m.photo}
  alt={m.name}
  loading="lazy"
  decoding="async"
/>

            <a className="abt-card__in" href={m.linkedin} target="_blank" rel="noreferrer" aria-label={`${m.name} on LinkedIn`}>
              in
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}
